export const GITHUB_LINK = "https://github.com/BhaveshWagh"
export const LINKEDIN_URL = "https://www.linkedin.com/in/bhavesh-wagh27/"
export const RESUME_DRIVE_URL = "https://rb.gy/tivml8"


export const YOUTUBE_GIT_URL = "https://github.com/BhaveshWagh/youtube-clone/tree/headerAndSidebar/youtube-clone"
export const YOUTUBE_HOSTED_URL = ""
export const SWIGGY_GIT_URL = ""

export const TODO_GIT_URL = "https://github.com/BhaveshWagh/learning-reactjs/tree/main/08todocontextlocal"
export const TODO_HOSTED_URL = "https://regal-kulfi-7d1bc6.netlify.app/"

export const MOVIE_GIT_URL =  "https://github.com/BhaveshWagh/Movies-Web-App"
export const MOVIE_HOSTED_URL =  "https://rad-biscotti-3a7dce.netlify.app/"


export const EMAIL = "bhaveshbm2711@gmail.com"
export const PHONE = "7058857983"
